import React from 'react';
import {
	BrowserRouter as Router,
	Route,
	Switch
} from 'react-router-dom';

import Call from './pages/Call';
import Result from './pages/Result';
import Top from './pages/Top';

function App() {
	return (
		<Router>
			<Switch>
				<Route path="/call">
					<Call></Call>
				</Route>
				<Route path="/result">
					<Result></Result>
				</Route>
				<Route path="/">
					<Top></Top>
				</Route>
			</Switch>
		</Router>
	);
}

export default App;
